export default __webpack_public_path__ + "static/media/icon_j.1ea42f00.svg";